<script>
export default {
    name: 'SaleReceipt',

     data () {

        return {
            receiptDetails: [],
        };
    },

    computed: {

        grandTotal () {

            if(!this.receiptDetails.length) return 0;

            return this.receiptDetails.map(rcD => parseFloat(rcD.expectedAmt)).reduce((sum, total) => sum + total);
        }
    },

    mounted() {

        Promise.allSettled([this.fetchReceiptDetails()]).then(() => {
            setTimeout(() => {
              window.print();  
            }, 300);

            window.onafterprint = function() { window.close() };
        }).catch(() => {});
    },

    methods: {

        fetchReceiptDetails() {
            let url = `CustomerSales/CashSalesReceiptDetails`;
                url += `?ReceiptNo=${this.$route.params.ReceiptNo}`;

            return this.$http.get(url).then(response => {
                       this.receiptDetails = response.data;
                   });
        },
    },
}
</script>

<template>
    <div class="w-full flex flex-wrap">
        <!-- <div class="w-full text-center my-1">
            <h5 class="font-bold">{{ receiptDetails.length && receiptDetails[0].company }}</h5>
            <h5 class="font-bold">{{ receiptDetails.length && receiptDetails[0].postalAddress }}</h5>
            <h5 class="font-bold">{{ receiptDetails.length && receiptDetails[0].physicalAddress }}</h5>
            <h6 class="font-bold">Email: {{ receiptDetails.length && receiptDetails[0].email }}</h6>
            <h6 class="font-bold">{{ receiptDetails.length && receiptDetails[0].cellphone }}</h6>
        </div> -->
        <tail-address-header></tail-address-header>
        <div class="w-full text-center my-1">
            <h5 class="text-base">Date: {{receiptDetails[0].date | formatDate}}</h5>
        </div>
        <div class="w-full text-center my-1">
            <h5 class="text-base">{{$route.params.ReceiptNo}}</h5>
        </div>
        <div class="w-full">
            <table class="table">
                <thead>
                    <tr>
                        <th class="text-sm">Item</th>
                        <th class="text-sm">Qty</th>
                        <th class="text-sm">Unit Price</th>
                        <th class="text-sm">Total</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(receiptDetail, index) in receiptDetails" :key="index">
                        <td class="text-xs">{{ receiptDetail.item }}</td>
                        <td class="text-xs">{{ receiptDetail.qty }}</td>
                        <td class="text-xs">{{ receiptDetail.unitPrice }}</td>
                        <td class="text-xs">{{ receiptDetail.expectedAmt }}</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <th colspan="2" class="text-sm text-right">Total:</th>
                        <th colspan="3" class="text-sm">{{ grandTotal }}</th>
                    </tr>
                    <tr>
                        <th colspan="2" class="text-xs text-right">Payment Mode:</th>
                        <th colspan="3" class="text-xs">{{ receiptDetails[0].mode }}</th>
                    </tr>
                    <tr>
                        <th colspan="2" class="text-xs text-right">Served By:</th>
                        <th colspan="3" class="text-xs text-left">{{ receiptDetails[0].userName }}</th>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
</template>
